import {Injectable} from '@angular/core';
import {Http, Headers,RequestOptions,RequestOptionsArgs} from '@angular/http';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class HttpClientService {

  constructor(private http: HttpClient) {}

  createAuthorizationHeader(headers: HttpHeaders) {
    headers.append('Content-Type', 'application/json' );
    headers.append('Authorization', 'Bearer ' + sessionStorage.getItem('access_token')); 
    headers.append('useridno', sessionStorage.getItem('userid')); 
  }

  get(url) {
     let headers = new HttpHeaders();
    this.createAuthorizationHeader(headers);
    return this.http.get(url,  {headers:headers});
  }

  post(url, data) {
     let headers = new HttpHeaders();
    this.createAuthorizationHeader(headers);
    return this.http.post(url, data,  {headers:headers});
  }

  put(url, data) {
      let headers = new HttpHeaders();
    this.createAuthorizationHeader(headers);
    return this.http.put(url, data, {headers:headers});
  }
}


// WEBPACK FOOTER //
// ./src/app/helpers/requestManager.ts